(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'torso/modules/Collection', './PrintableModel', 'services/printableExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var printableExtService = require('./../urls').printableExtService;
    module.exports = factory(require('underscore'), require('backbone-torso/modules/Collection'), require('./PrintableModel'), printableExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, TorsoCollection, PrintableModel, printableExtService) {
  'use strict';

  /**
   * Receives printables from the PrintableExtService which serves the PrintableDTO resource
   * @class printableVecnaIdsCollection
   * @static
   */
  return new (TorsoCollection.extend({
    model: PrintableModel,
    url: printableExtService,
    fetchHttpAction: 'POST',

    /**
     * @property fullListSize {Number} the total number of items that match the criteria
     */
    fullListSize: 0,

    /**
     * Only makes sense for private collections.  Nobody cares (or shouldn't) how the cache is ordered.
     * @method comparator
     * @param model {Backbone.Model} the model to index for this collection.
     * @returns {Number} a unique index that can be used to sort this model.
     *          Represents the index of this model's id in the tracked ids of this private collection.
     */
    comparator: function(model) {
      if (!this.trackedIds) {
        return undefined;
      }
      return _.indexOf(this.trackedIds, model.get(model.idAttribute));
    },

    /**
     * method fetchIdsByCriteria
     * @param criteria {Object|String} either the object criteria to fetch or
     * @param options {Object} context options sent in by DataService.
     *   @param options.privateCollection {TorsoCollection} The collection that made the original call.
     *                                                      The fullListSize property will be set on it when the response is parsed.
     * @returns {jQuery.Deferred} that will resolve with the fetched ids and reject if the fetch failed.
     */
    fetchIdsByCriteria: function (criteria, options) {
      options = options || {};
      if (!_.isObject(criteria)) {
        throw 'Criteria should be an object with properties defined by PrintableCriteria.java';
      }
      return $.ajax({
        url: printableExtService + '/criteria',
        contentType: 'application/json',
        type: 'POST',
        data: JSON.stringify(criteria),
        dataType: 'json'
      }).then(function(response) {
        // This is being called on the cache collection by DataService, but the full list size only makes sense in the
        // context of the private collection (since multiple private collections could be using this same method on the cache).
        options.privateCollection.fullListSize = response.fullListSize || 0;
        return response.list;
      });
    },

    /**
     * Fetches all printables
     * @method fetchAll
     * @returns {jQuery.Deferred} that will resolve with all the printable DTOs
     */
    fetchAll: function() {
      return $.ajax({
        url: printableExtService,
        type: 'GET',
        dataType: 'json'
      });
    }
  }))();
}));
